import * as ActionTypes from 'modules/lockers/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

const initialState = null;

const isStarting = (_, { payload }) => payload.id;

const isEnding = () => null;

export default createReducer(initialState, {
  [ActionTypes.DELETE_LOCKER_REQUEST]: isStarting,
  [ActionTypes.DELETE_LOCKER_SUCCESS]: isEnding,
  [ActionTypes.DELETE_LOCKER_FAILURE]: isEnding,
});
